<template>
  <div class="card">
    <h3 class="card-title">Cargar persona</h3>
    <form @submit.prevent="save">
      <div class="cols2" v-if="persona">
        <pd-input
          v-model="persona.nombre"
          id="nombre"
          label="Nombre"
          placeholder="Ej: Apellido Nombre"
          :required="enviado && !persona.nombre"
        ></pd-input>
        <pd-input
          v-model="persona.cuil"
          id="cuil"
          label="CUIL"
          placeholder="Sin guiones"
          inputmode="numeric"
          :required="enviado && !persona.cuil"
        ></pd-input>
        <pd-input
          v-model="persona.email"
          id="email"
          label="Email"
          placeholder="ejemplo@adc.net"
        ></pd-input>
        <pd-input
          v-model="persona.telefono_fijo"
          id="telefono"
          label="Teléfono (opcional)"
          placeholder="Solo números"
          inputmode="numeric"
        ></pd-input>

        <div class="form-group">
          <label class="form-label">Celular (sin 0 ni 15)</label>
          <div class="input-group">
            <div class="input-group input-group-prepend">
              <div class="input-group-prepend">
                <span class="input-group-text">0</span>
              </div>
              <input
                id="caracteristica"
                placeholder="Ej:2954"
                type="number"
                class="form-control"
                inputmode="numeric"
                v-model="persona.caracteristica_celular"
              />
            </div>
            <div class="input-group input-group-append"  style="flex:2">
              <div class="input-group-prepend">
                <span class="input-group-text">15</span>
              </div>
              <input
                id="numero_celular"
                placeholder="Ej: 555555"
                type="number"
                class="form-control"
                inputmode="numeric"
                v-model="persona.numero_celular"
              />
            </div>
          </div>
        </div>
        <pd-input
          v-model="persona.domicilio"
          id="domicilio"
          label="Domicilio (opcional)"
          placeholder="Domicilio"
        ></pd-input>
        <pd-input
          v-model="persona.localidad"
          id="localidad"
          label="Localidad (opcional)"
          placeholder="Localidad"
        ></pd-input>
        <pd-input
          v-model="persona.provincia"
          id="provincia"
          label="Provincia (opcional)"
          placeholder="Provincia"
        ></pd-input>
        <pd-input
          v-model="persona.codigo_postal"
          id="codigo_postal"
          label="Código postal (opcional)"
          placeholder="Solo números"
          inputmode="numeric"
        ></pd-input>
        <pd-input
          v-model="persona.numero_legajo"
          id="numero_legajo"
          label="N° de legajo"
          placeholder="Solo números"
          inputmode="numeric"
          :required="enviado && !persona.numero_legajo"
        ></pd-input>
        <pd-input
          v-model="persona.fecha_nacimiento"
          id="fecha_nacimiento"
          label="Fecha de nacimiento"
          placeholder="Fecha de nacimiento"
          type="date"
          :required="enviado && !persona.fecha_nacimiento"
        ></pd-input>
        <pd-input
          v-model="persona.fecha_ingreso"
          id="fecha_ingreso"
          label="Fecha de ingreso"
          placeholder="Fecha de ingreso"
          type="date"
          :required="enviado && !persona.fecha_ingreso"
        ></pd-input>
        <pd-input
          v-if="user && (user.tipo === 'RRHH' || user.tipo === 'dev')"
          v-model="persona.fecha_antiguedad_reconocida"
          id="fecha_antiguedad_reconocida"
          label="Fecha antigüedad reconocida"
          placeholder="Solo para reingresantes"
          type="date"
        ></pd-input>
        <suggest
          id="area"
          label="Área"
          placeholder="Buscar área.."
          :value="persona.area"
          :data="areas"
          :items="itemsArea"
          @selected="areaSelected"
          :required="enviado && !persona.area_id"
        ></suggest>
        <suggest
          id="sucursal"
          label="Sucursal"
          placeholder="Buscar sucursal.."
          :value="persona.sucursal"
          :data="sucursales"
          :items="itemsSucursales"
          @selected="sucursalSelected"
          :required="enviado && !persona.sucursal_id"
        ></suggest>
        <suggest
          id="categoria"
          label="Categoría"
          placeholder="Buscar categoría.."
          :value="persona.categoria"
          :data="categorias"
          :items="itemsCategorias"
          @selected="categoriaSelected"
          :required="enviado && !persona.categoria_id"
        ></suggest>
        <suggest
          id="obra_social"
          label="Obra social"
          placeholder="Buscar obra social.."
          :value="persona.obra_social"
          :data="obras_sociales"
          :items="itemsObrasSociales"
          @selected="obraSocialSelected"
          :required="enviado && !persona.obra_social_id"
        ></suggest>
        <pd-input
          v-model="persona.estado"
          id="estado"
          select
          label="Estado"
          placeholder="Seleccione estado"
        >
        <template slot="options">
          <option value="Habilitado">Habilitado</option>
          <option value="Inhabilitado">Inhabilitado</option>
        </template>
      </pd-input>
      </div>
      <button type="submit" class="btn btn-right btn-primary">Guardar</button>
    </form>
  </div>
</template>
<script>
import Suggest from "@/components/elements/Suggest";
import { mapState } from "vuex";
import { PersonasService } from "@/modules/personas/services/PersonasServices";
import { AreaServices } from "@/modules/areas/services/AreaServices";
import { SucursalServices } from "@/modules/sucursales/services/SucursalServices";
import { CategoriaServices } from "@/modules/categorias/services/CategoriaServices";
import { ObraSocialServices } from "@/modules/obras_sociales/services/ObraSocialServices";
import Swal from "sweetalert2";
export default {
  name: "EditarPersona",
  data() {
    return {
      persona: null,
      descripcion: "",

      area: null,
      areas: null,
      itemsArea: AreaServices.dataList(),

      sucursal: null,
      sucursales: null,
      itemsSucursales: SucursalServices.dataList(),

      categoria: null,
      categorias: null,
      itemsCategorias: CategoriaServices.dataList(),

      
      obra_social: null,
      obras_sociales: null,
      itemsObrasSociales: ObraSocialServices.dataList(),


      enviado: false,
    };
  },
  components: {
    Suggest,
  },
  validations: {
    ...AreaServices.validations,
  },
  computed: {
    ...mapState(["user"]),
  },
  mounted() {
    AreaServices.api.getAll().then((areas) => (this.areas = areas));
    SucursalServices.api
      .getAll()
      .then((sucursales) => (this.sucursales = sucursales));
    CategoriaServices.api
      .getAll()
      .then((categorias) => (this.categorias = categorias));
    ObraSocialServices.api
      .getAll()
      .then((obras_sociales) => (this.obras_sociales = obras_sociales));
    PersonasService.api.find(this.$route.params.id).then((response) => {
      this.area = response.persona.area;
      this.sucursal = response.persona.sucursal;
      this.categoria = response.persona.categoria;
      this.obra_social = response.persona.obra_social
      this.persona = response.persona;
      console.log(response.persona)
    });
  },
  methods: {
    areaSelected(area) {
      this.area = area;
      this.persona.area_id = area.id;
      this.persona.gerencia_id = area.gerencia_id;
    },
    sucursalSelected(sucursal) {
      this.sucursal = sucursal;
      this.persona.sucursal_id = sucursal.id;
    },
    categoriaSelected(categoria) {
      this.categoria = categoria;
      this.persona.categoria_id = categoria.id;
    },
    obraSocialSelected(obra_social) {
      this.obra_social = obra_social;
      this.persona.obra_social_id = obra_social.id;
    },
    save() {
      this.enviado = true;
      PersonasService.api
        .put(this.persona.id, this.persona)
        .then((r) => {
          Swal.fire(
            "Éxito",
            `<p><b>${r.persona.nombre}</b> se ha guardado con éxito</p>`,
            "success"
          );
          this.$router.push({ name: "ListarPersonas" });
        })
        .catch((e) => {
          Swal.fire("Error", `<p>${e}</p>`, "error");
        });
    },
  },
};
</script>